import { createFileRoute, redirect } from '@tanstack/react-router'

// The Incident Knowledge Base moved into the organisation's incident settings
// (GitHub #340, item 4). Old links and bookmarks keep working through this redirect.
export const Route = createFileRoute(
  '/_authenticated/_organization/incidents/knowledge-base'
)({
  beforeLoad: () => {
    throw redirect({
      to: '/organizations/settings/incident-knowledge-base',
      replace: true,
    })
  },
})
